import { Component, Input, OnInit } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { PageService } from '../../../core/services/page.service'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-lending-library',
    templateUrl: './lending-library.component.html',
    styleUrls: ['./lending-library.component.scss'],
    standalone: false
})
export class LendingLibraryComponent implements OnInit{
  constructor(
    public logger: NGXLogger,
    public page: PageService,
    public sharedDataService: SharedDataService
    ) {
  }
  @Input() content = [{title: '', text: '', textDesktop: ''}]
  @Input() defaultData: any = {}
  @Input() breakpoints: any = {}


  innerTitle = ''
  innerText = ''
  innerTextDesktop = ''
  activeComponent = -1


  ngOnInit() {
    this.fillDefault()
    this.setInnerDefault()
  }

  async fillDefault() {
    const timeout = 100

    while (!this.defaultData) {
      await new Promise((resolve, reject) => setTimeout(resolve, timeout))
    }
    this.setInnerDefaultFrom(this.defaultData)
  }

  setInnerDefaultFrom(data) {
    this.innerTitle = data.defaultTitle
    this.innerText = data.defaultText
    this.innerTextDesktop = data.defaultTextDesktop
  }

  setInnerDefault(arg?: boolean) {
    if (!this.defaultData) {
      return
    }
    this.setInnerDefaultFrom(this.defaultData)
  }

  setInnerContent(title, text, textDesktop, active){
    if (this.activeComponent === active){
      this.setInnerDefault()
      this.activeComponent = -1
    }
    else{
      this.innerText = text
      this.innerTextDesktop = textDesktop
      this.innerTitle = title
      this.activeComponent = active
    }
  }

}
